import { ENTITY_STATUS } from "../../config/constants";
import { getDocsAndFields } from "../../helper/utils";
import {
  FORBIDDEN_ACTION,
  LOGOUT_SUCCESS,
  UNAUTHORIZED_USER,
} from "../types/authTypes";
import {
  ADD_LEDGER_HEAD_ERROR,
  ADD_LEDGER_HEAD_SUCCESS,
  COMMON_LOADING_RESET,
  COMMON_LOADING_SET,
  DELETE_LEDGER_HEAD_ERROR,
  DELETE_LEDGER_HEAD_SUCCESS,
  EXPENSE_TYPES_ERROR,
  EXPENSE_TYPES_LOADING,
  EXPENSE_TYPES_SUCCESS,
  GET_LATEST_PROJECTS_ERROR,
  GET_LATEST_PROJECTS_SUCCESS,
  GET_LEDGER_HEAD_ERROR,
  GET_LEDGER_HEAD_SUCCESS,
  GET_ROLES_ERROR,
  GET_ROLES_SUCCESS,
  GET_STAT_ERROR,
  GET_STAT_SUCCESS,
  GET_TOOLS_ERROR,
  GET_TOOLS_SUCCESS,
  SET_COMMON_REDUCER,
  SETTINGS_META_ERROR,
  SETTINGS_META_SUCCESS,
  USER_SETTINGS_ERROR,
  USER_SETTINGS_SUCCESS,
  USER_SETTINGS_UPDATE_ERROR,
  USER_SETTINGS_UPDATE_SUCCESS,
  GET_DOC_FIELDS_SUCCESS,
  GET_DOC_FIELDS_ERROR,
} from "../types/commonTypes";

const initState = {
  loading: false,
  expenseTypes: [],
  appSettings: [],
  userSettings: [],
  userSettingUpdateSuccess: false,
  userSettingUpdateError: false,
  deleteLedgerSuccess: false,
  deleteLedgerError: false,
  tools: [],
  toolDocTypes: {},
  docTypeFields: {},
  roles: [],
  allDocs: [],
  masterDocFields: {},
  sidebarOpen: true,
};

const commonReducer = (state = initState, action) => {
  switch (action.type) {
    case COMMON_LOADING_SET:
      return {
        ...state,
        loading: true,
      };
    case COMMON_LOADING_RESET:
      return {
        ...state,
        loading: false,
      };
    case EXPENSE_TYPES_LOADING:
      return {
        ...state,
        expenseTypes: [],
      };
    case EXPENSE_TYPES_SUCCESS:
      return {
        ...state,
        expenseTypes: action.payload,
      };
    case EXPENSE_TYPES_ERROR:
      return {
        ...state,
        expenseTypes: [],
      };
    case SETTINGS_META_SUCCESS:
      return {
        ...state,
        appSettings: action?.payload,
      };
    case SETTINGS_META_ERROR:
      return {
        ...state,
        appSettings: [],
      };
    case USER_SETTINGS_SUCCESS:
      return {
        ...state,
        userSettings: action?.payload,
      };
    case USER_SETTINGS_ERROR:
      return {
        ...state,
        userSettings: [],
      };
    case USER_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        userSettingUpdateSuccess: true,
        userSettingUpdateError: false,
      };
    case USER_SETTINGS_UPDATE_ERROR:
      return {
        ...state,
        userSettingUpdateSuccess: false,
        userSettingUpdateError: true,
      };
    case GET_LEDGER_HEAD_SUCCESS:
      return {
        ...state,
        ledgerHeads:
          action.payload.rows.filter(
            (bill) => bill._status !== ENTITY_STATUS.deleted,
          ) || [],
      };
    case GET_LEDGER_HEAD_ERROR:
      return {
        ...state,
        ledgerHeads: [],
      };
    case ADD_LEDGER_HEAD_SUCCESS:
      return {
        ...state,
        addLedgerSuccess: true,
        addLedgerError: false,
      };
    case ADD_LEDGER_HEAD_ERROR:
      return {
        ...state,
        addLedgerSuccess: false,
        addLedgerError: true,
      };
    case DELETE_LEDGER_HEAD_SUCCESS:
      return {
        ...state,
        deleteLedgerSuccess: true,
        deleteLedgerError: false,
      };
    case DELETE_LEDGER_HEAD_ERROR:
      return {
        ...state,
        deleteLedgerSuccess: false,
        deleteLedgerError: false,
      };
    case SET_COMMON_REDUCER:
      return {
        ...state,
        ...action.payload,
      };
    case GET_TOOLS_SUCCESS:
      let toolDocs = {};
      let docFields = {};
      let allDocs = [];
      if (action.payload && action.payload[0]) {
        let temp = getDocsAndFields(action.payload[0]?.Children);
        docFields = temp.docFields;
        toolDocs = temp.toolDocs;
        allDocs = temp.allDocs;
      }

      return {
        ...state,
        tools:
          action.payload && action.payload[0]
            ? action.payload[0]?.Children
            : [],
        docFields,
        toolDocs,
        allDocs,
      };
    case GET_TOOLS_ERROR:
      return {
        ...state,
        tools: [],
        docFields: null,
        toolDocs: null,
      };
    case GET_STAT_SUCCESS:
      return {
        ...state,
        stat: action.payload,
      };
    case GET_STAT_ERROR:
      return {
        ...state,
        stat: null,
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.rows,
      };
    case GET_ROLES_ERROR:
      return {
        ...state,
        roles: [],
      };

    case GET_LATEST_PROJECTS_SUCCESS:
      return {
        ...state,
        projectsLatest: action?.payload,
      };
    case GET_LATEST_PROJECTS_ERROR:
      return {
        ...state,
        projectsLatest: [],
      };
    case GET_DOC_FIELDS_SUCCESS:
      return {
        ...state,
        masterDocFields: action?.payload,
      };
    case GET_DOC_FIELDS_ERROR:
      return {
        ...state,
        masterDocFields: [],
      };
    case LOGOUT_SUCCESS:
    case FORBIDDEN_ACTION:
    case UNAUTHORIZED_USER:
      return initState;
    default:
      return state;
  }
};

export default commonReducer;
